export function getInitials(fullName: string): string | undefined {
  return fullName
    ? fullName
        .split(/\s/)
        .map((name, index, names) => {
          if (index === 0 || index === names.length - 1) return name.charAt(0);
        })
        .join('')
        .toLocaleUpperCase()
    : undefined;
}
